module.exports = __webpack_public_path__ + "images/common/item_watch_recommendation_img_02_007b34bbf3feb1518ac0d947415911f7.png";